import dynamic from 'next/dynamic';

const OnboardingDynamic = dynamic(
  async () => import('./index').then((m) => m.Onboarding),
  {
    ssr: false,
    loading: () => null,
  }
);

export { OnboardingDynamic };
